<div class="password-reset">
  <div class="password-reset_svg">
    <stxt-svg-icon
      [iconConfig]="closeSvg"
      (click)="closeModal()"
      (keydown.enter)="closeModal()"
      tabindex="0"
      class="close_svg"
    ></stxt-svg-icon>
  </div>
  <form [formGroup]="passwordResetForm" (keydown.enter)="onEnterKeyPress($event)" tabindex="-1">
    <div class="password-reset_wrapper">
      <div class="password-reset_header">
        <img src="/assets/icons/stxt_favicon_d2c_auth.svg" alt="Justsext logo" />
        <p class="password-reset_header__title">RESET PASSWORD</p>
        <p *ngIf="!resetCodeSent" class="password-reset_header__subheading">
          Enter the email you signed up with to receive a password reset code.
        </p>
        <p *ngIf="resetCodeSent" class="password-reset_header__subheading">
          A reset code has been sent to your email.
        </p>
      </div>
      <ng-container *ngIf="!resetCodeSent">
        <stxt-input
          [inputConfig]="emailInput"
          formControlName="email"
          class="password-reset_input"
        ></stxt-input>
        <stxt-button
          [disabled]="!passwordResetForm.get('email')?.valid"
          [buttonConfig]="getResendCodeButton"
          (click)="onSendCode()"
          (keydown.enter)="onSendCodeKeyPress($event)"
          ngbAutofocus
          class="resend_button"
        >
          {{ getResendCodeButton.text }}
        </stxt-button>
        <span (keydown.enter)="returnToLogin()" (click)="returnToLogin()" tabindex="0">
          Return to login
        </span>
      </ng-container>
      <ng-container *ngIf="resetCodeSent">
        <stxt-input
          [inputConfig]="codeInput"
          formControlName="code"
          class="password-reset_input"
        ></stxt-input>
        <stxt-input
          [inputConfig]="newPasswordInput"
          [hintText]="newPasswordInput.hintText"
          formControlName="password"
          class="password-reset_input"
        ></stxt-input>
        <stxt-button
          [disabled]="
            !passwordResetForm?.get('code')?.valid || !passwordResetForm?.get('password')?.valid
          "
          ngbAutofocus
          [buttonConfig]="submitCodeButton"
          (click)="onSubmitCode()"
          (keydown.enter)="onSubmitCodeKeyPress($event)"
          tabindex="0"
          class="resend_button"
        >
          {{ submitCodeButton.text }}
        </stxt-button>
        <stxt-resend-code
          #resendCode
          [usageCase]="EResendCodeUsage.PasswordReset"
          [email]="passwordResetForm?.get('email')?.value"
          (resendCodeSent)="onResendCode()"
          class="password-reset_resend"
        ></stxt-resend-code>
      </ng-container>
    </div>
  </form>
</div>
